import { Component } from "react";

// Shown while a lazily-loaded page's code is downloading. Deliberately plain:
// it appears for a moment on a slow connection, inside the app shell.
export function RouteFallback() {
  return (
    <div role="status" aria-live="polite" style={{ padding: 24, color: "#8a99b3", fontSize: 13, fontFamily: "'DM Sans', sans-serif" }}>
      Loading…
    </div>
  );
}

const RELOAD_KEY = "clinic_chunk_reload_at";

// A page's code is split into its own file named by a content hash. After a
// deploy, a tab opened before it still points at files that no longer exist,
// so the import fails (ChunkLoadError). Reload once to pick up the new build;
// if it fails again within a minute, show a button instead of looping.
export class ChunkErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    const isChunkError = error && (error.name === "ChunkLoadError" || /Loading (CSS )?chunk .* failed|dynamically imported module/i.test(error.message || ""));
    if (!isChunkError) return;
    try {
      const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
      if (Date.now() - last > 60000) {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
        window.location.reload();
      }
    } catch (e) {
      // sessionStorage unavailable: fall through to the manual button.
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" style={{ padding: 24, fontFamily: "'DM Sans', sans-serif", color: "#1e3050" }}>
        <p style={{ fontWeight: 700, margin: "0 0 6px" }}>This page could not be loaded</p>
        <p style={{ margin: "0 0 12px", fontSize: 13, color: "#4a6080" }}>
          The app may have been updated, or the connection dropped. Reloading usually fixes it.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ padding: "8px 16px", borderRadius: 8, border: "none", background: "#1e3a8a", color: "white", fontWeight: 600, cursor: "pointer" }}
        >
          Reload
        </button>
      </div>
    );
  }
}
